import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { take, map } from 'rxjs/operators';

import { CountryService } from './country.service';

@Pipe({
  name: 'country',
  pure: false,
  standalone: false
})
export class CountryPipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(
    private countryService: CountryService,
    private injector: Injector
  ) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  transform(value: string): string {
    return !value
      ? ''
      : this.asyncPipe.transform(
          this.countryService.worldwideCountries$.pipe(
            take(1),
            map((classifiers) => classifiers.find((classifier) => classifier.id === value)?.label)
          )
        );
  }
}
